<template>
    <div class="page">
        <div class="loginBox">
            <el-card class="box-card">
                <h3 class="center">欢迎登录</h3>
                <el-form ref="loginForm" :model="loginForm" label-width="80px" class="top">
                    <el-input placeholder="请输入账号" v-model="loginForm.userName">
                        <template slot="prepend">
                            <i class="el-icon-user"></i>
                        </template>
                    </el-input>
                    <el-input placeholder="请输入密码" v-model="loginForm.password" type="password" show-password class="top">
                        <template slot="prepend">
                            <i class="el-icon-lock"></i>
                        </template>
                    </el-input>
                    <el-button type="primary" :loading="loading" :disabled="locked" @click="handleLogin" style="width: 100%;margin-top: 30px">{{ locked ? '账号已锁定，请稍后重试' : '立即登录' }}</el-button>
                </el-form>
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'login',
    components: {},
    props: {},
    watch: {},
    data() {
        return {
            loginForm: {},
            loading: false,
            locked: false, // 账号被锁定（响应体 code=429）时禁用登录按钮
        };
    },

    mounted() {

    },
    created() {

    },

    methods: {
        handleLogin() {
            const { userName, password } = this.loginForm
            if (userName && password) {
                const param = {
                    userName,
                    password,
                };
                this.loading = true;
                this.$store.dispatch("user/login", param).then(response => {
                    this.$router.push({
                        path: "/info"
                    });
                }).catch((error) => {
                    // 登录失败：响应体 code（错误提示已由全局拦截器展示）
                    // 401 = 用户名或密码错误（含剩余次数）；429 = 已触发锁定
                    if (error && error.code === 429) {
                        this.locked = true;
                    }
                }).finally(() => {
                    this.loading = false;
                });
            } else {
                this.$message.warning("账号或密码不能为空！");
                return false;
            }
        }
    },
};
</script>

<style lang="scss" scoped>
body {
  padding-top: unset;
}
.page {
    height: 100vh;

    .loginBox {
        width: 100%;
        height: 100%;
        background-image: url(../../assets/login-bg-2.jpg);
        background-size: cover;
        background-position: 50%;
        position: relative;
        display: flex;
        align-items: center;

        @media (max-width: 768px) {
            background-size: contain;
        }
    }

    .box-card {
        width: 400px;
        position: absolute;
        right: 150px;

        .bottom-btn {
            font-size: 14px;
            margin-top: 5px;
        }

        @media (max-width: 768px) {
            width: 300px;
            right: 50px;
        }

        @media (max-width: 480px) {
            width: 100%;
            right: 0;
            padding: 10px;
        }
    }
}
</style>
